import {Spin} from "antd";
import assert from "assert";
import parse from "html-react-parser";
import React, {ReactNode} from "react";
import {StyleType, WheelData} from "react-custom-roulette/dist/components/Wheel/types";
import {connect} from "react-redux";
import {bindActionCreators, Dispatch} from "redux";
import pointer from "../../assets/images/wheel-pointer.png";
import ApiErrorModal from "../../components/Modals/ApiErrorModal/ApiErrorModal";
import CongratsModal from "../../components/Modals/CongratsModal/CongratsModal";
import Wheel4p from "../../components/Wheel4p/Wheel4p";
import {wheelConsumeHash, wheelFetchHashDetail} from "../../core/actions/wheel";
import {Utilities} from "../../core/helpers/utilities";
import {WheelInitData} from "../../core/models/custom/wheelInitData";
import {ErrorDto} from "../../core/models/dtos/error.dto";
import {HashDetailDto} from "../../core/models/dtos/hashDetail.dto";
import {IStore} from "../../core/reducers";
import FirebaseService from "../../core/services/firebase.service";
import "./HomePage.scss";


interface IProps {
  match: any;
  loadingHashDetail: boolean;
  dataHashDetail?: HashDetailDto;
  errorHashDetail?: ErrorDto;
  loadingHashConsume: boolean;
  dataHashConsume: boolean;
  errorHashConsume?: ErrorDto;
  apiError?: ErrorDto;
  wheelFetchHashDetail: (hash: string) => void;
  wheelConsumeHash: (hash: string) => void;
}

interface IState {
  intervalId?: NodeJS.Timeout;
  isTicketUsed: boolean;
  winnerPrize?: string;
}

class HomePage extends React.Component<IProps> {
  state: IState = {
    intervalId: undefined,
    isTicketUsed: false,
    winnerPrize: undefined,
  }

  private readonly hash: string;
  private readonly bipUrl: string = 'bip://officialAccounts?oaid=36002&at=subscribe';
  private readonly otherUrl: string = 'https://taraftarkart.fenerbahce.org';
  private readonly pageUrl: string = window.location.href;
  private readonly styleOdd: StyleType = {backgroundColor: '#FFE600', textColor: '#191919'};
  private readonly styleEven: StyleType = {backgroundColor: '#FFFFFF', textColor: '#191919'};
  private readonly dummyWheelData: WheelData[] = [
    {option: 'Haftalık 10 GB', style: this.styleOdd},
    {option: 'Günlük 50 MB', style: this.styleEven},
    {option: 'Haftalık 1 GB', style: this.styleOdd},
    {option: 'Günlük 500 MB', style: this.styleEven},
    {option: 'Günlük 250 MB', style: this.styleOdd},
    {option: 'Günlük 5 GB', style: this.styleEven},
    {option: 'Günlük 1 GB', style: this.styleOdd},
    {option: 'Günlük 500 MB', style: this.styleEven},
    {option: 'Günlük 2 GB', style: this.styleOdd},
    {option: 'Günlük 100 MB', style: this.styleEven},
  ];

  constructor(props: IProps) {
    super(props);
    const hash = Utilities.getQueryParam('hash');
    this.hash = hash ? hash : '';
  }

  async componentDidMount(): Promise<void> {
    this.props.wheelFetchHashDetail(this.hash);
  }

  componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<{}>, snapshot?: any) {
    if (prevProps.loadingHashDetail && !this.props.loadingHashDetail) {
      if (this.props.dataHashDetail) {
        this.setIntervalWheelCreated();
      } else if (this.props.errorHashDetail) {
        this.setState({
          isTicketUsed: true,
        });
      }
    }

    if (prevProps.loadingHashConsume && !this.props.loadingHashConsume) {
      if (this.props.dataHashConsume) {
        assert(this.props.dataHashDetail);
        const initData = this.getWheelInitDataFromHashDetail(this.props.dataHashDetail);
        const winnerPrize: string = initData.data[initData.winnerIndex].option;
        this.setState({
          isTicketUsed: true,
          winnerPrize: winnerPrize,
        });
      }
    }
  }

  private getWheelInitDataFromHashDetail(hashDetail: HashDetailDto): WheelInitData {
    const data: WheelData[] = [];
    let winnerIndex: number = 0;
    hashDetail.offers.forEach((offer, index) => {
      data.push({option: offer.name, style: index % 2 === 0 ? this.styleEven : this.styleOdd});
      if (offer.id === hashDetail.offerId) {
        winnerIndex = index;
      }
    });
    return {data, winnerIndex};
  }

  private setIntervalWheelCreated(): void {
    const intervalId = setInterval(() => {
      const wheelPointer = document.getElementsByTagName('IMG')[0];
      if (wheelPointer) {
        this.wheelCreated(wheelPointer);
      }
    }, 1);
    this.setState({intervalId});
  }

  private wheelCreated(wheelPointer: Element): void {
    wheelPointer.setAttribute("src", pointer);
    if (this.state.intervalId) {
      clearInterval(this.state.intervalId);
    }
  }

  private handleFinish(): void {
    this.props.wheelConsumeHash(this.hash);
  }

  private handleGoToBip() {
    Utilities.goToUrl(this.bipUrl);
  }

  private handleRetry() {
    Utilities.goToUrl(this.pageUrl);
  }

  private handleOtherService() {
    Utilities.goToUrl(this.otherUrl);
  }

  private getWheel(hashDetail: HashDetailDto): ReactNode {
    const initData = this.getWheelInitDataFromHashDetail(hashDetail);
    return (
      <div className="wheel-wrapper">
        <Wheel4p
          isTicketUsed={this.state.isTicketUsed}
          wheelData={initData.data}
          winnerIndex={initData.winnerIndex}
          callbackFinished={() => this.handleFinish()}
          callbackGoToBip={() => this.handleGoToBip()}
          callbackOtherService={() => this.handleOtherService()}
        />
      </div>
    );
  }

  private getDummyWheel(isButtons: boolean = false): ReactNode {
    return (
      <div className="wheel-wrapper">
        <Wheel4p
          isTicketUsed={isButtons}
          wheelData={this.dummyWheelData}
          winnerIndex={0}
          callbackFinished={() => {
          }}
          callbackGoToBip={() => this.handleGoToBip()}
          callbackOtherService={() => this.handleOtherService()}
        />
      </div>
    );
  }

  private renderContent(): ReactNode {
    if (this.props.loadingHashDetail) {
      return <Spin size="large"/>;
    } else if (this.props.dataHashDetail) {
      return this.getWheel(this.props.dataHashDetail);
    } else if (this.props.errorHashDetail) {
      return this.getDummyWheel();
    }
    return <React.Fragment/>;
  }

  render() {
    return (
      <div
        id="home-page"
        className="page"
      >
        <div className="header">
          <p className="heading">
            {parse(FirebaseService.getValue(FirebaseService.wheel_header))}
          </p>
        </div>

        <p className="text">
          {parse(FirebaseService.getValue(FirebaseService.wheel_description))}
        </p>

        {this.renderContent()}

        <CongratsModal
          winnerPrize={this.state.winnerPrize}
          callbackGoToBip={() => this.handleGoToBip()}
          callbackOtherService={() => this.handleOtherService()}
        />

        <ApiErrorModal
          apiError={this.props.apiError}
          callbackGoToBip={() => this.handleGoToBip()}
          callbackRetry={() => this.handleRetry()}
        />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators(
    {
      wheelFetchHashDetail,
      wheelConsumeHash,
    },
    dispatch
  );
};

const mapStateToProps = (store: IStore) => {
  return {
    loadingHashDetail: store.wheel.hashDetail.loading,
    dataHashDetail: store.wheel.hashDetail.data,
    errorHashDetail: store.wheel.hashDetail.error,
    loadingHashConsume: store.wheel.hashConsume.loading,
    dataHashConsume: store.wheel.hashConsume.data,
    errorHashConsume: store.wheel.hashConsume.error,
    apiError: store.app.apiError,
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
